export enum PreventionSubClassificationType {
  OBJECT_PROTECTION_METEOROGICAL_NATURAL_HAZARDS = 'OBJECT_PROTECTION_METEOROGICAL_NATURAL_HAZARDS',
}
